import { ReactNode } from "react";
import "./ListTable.scss";

export enum ListTableMode {
  Table = 0,
  List = 1,
}

interface ListTableProps {
  children: ReactNode;
  mode?: ListTableMode;
}

const ListTable = ({
  children,
  mode = ListTableMode.Table,
}: ListTableProps) => {
  return (
    <div className={mode === ListTableMode.Table ? "listTable" : "listList"}>
      {children}
    </div>
  );
};

export default ListTable;
